import React, { useEffect, useState } from "react";

import Dashboard from "./components/Dashboard";
import DocumentsValidated from "./components/DocumentsValidated";
import DocumentsInProgress from "./components/DocumentsInProgress";
import Preferences from "./components/Preferences";
import FormArchive from "../formArchive";
import CreateObject from "../create-object";
import { useLocation, useParams } from "react-router-dom"
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import axios from "axios"
import { Modal, Button, InputGroup, Container, Input, InputGroupAddon, InputGroupText, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { useDispatch, useSelector } from "react-redux";
import { updateTitle } from "../../redux/updatePageHeadeSlice";
import { Tab, Tabs } from "react-bootstrap";

const Form = () => {
  const [showPreferences, setShowPreferences] = useState(false);
  const [isdashPrefMinimized, setIsDashPrefMinimized] = useState(false);
  const [modalType, setmodalType] = useState("");
  // const { form_name } = useParams();
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const history = useHistory()
  const togglePreference = () => {
    setShowPreferences((prev) => !prev);
  };
  const formName = pathname.split('/')

  useEffect(() => {
    dispatch(updateTitle(formName[2]))
  }, [formName])

  return (
    <div className="h-full flex flex-col">
      {/* Ajout du Dashboard pour tester getFormDashboard */}
      {/* <Dashboard 
        togglePreference={togglePreference} 
        minimized={isdashPrefMinimized} 
        setMinimized={setIsDashPrefMinimized} 
      /> */}
      
      <DocumentsValidated />
    </div>
  );
};

const DashboardPreferenceWrapper = styled.div`
  display: flex;
  position: relative;
`;

export default Form;
